/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.controller('SchemaMappingStep', [
  '$scope',
  '$translate',

  function ($scope, $translate) {
    $scope.schemaMappingStep = $scope.$parent.createStep(
      $translate.instant(`component-editor.step-schema-mapping.${$scope.component.componentType}.closed`),
      $translate.instant(`component-editor.step-schema-mapping.${$scope.component.componentType}.active`),
    );

    $scope.schemaMappingStep.validate = function () {
      return true;
    };

    $scope.onFieldsValidityChange = (schemaMappingValid) => {
      if (schemaMappingValid) {
        $scope.schemaMappingStep.tags = _.map(this.recordsCopy, function (record) {
          return {
            name: _.escape(record.column_name),
          };
        });
      } else {
        $scope.schemaMappingStep.tags = [];
      }

      $scope.schemaMappingStep.error = $scope.connectionStep.valid !== undefined ? !schemaMappingValid : false;
      $scope.schemaMappingStep.valid = $scope.connectionStep.valid !== undefined ? schemaMappingValid : true;

      if (!$scope.componentBaseStep.valid || !$scope.schemaMappingStep.valid) {
        $scope.schemaMappingStep.valid = false;
      }
    };
  },
]);
